var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-with-bg page-full 404-page"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("404 Page Not Found")])]),_c('p',[_vm._v("The page is not found.")])])
}]

export { render, staticRenderFns }